var text;

function message(text) 
{
	$('#message .message').html(text);
	$('#message').modal();	
	
	$('.modal.fade.in').each(function()
	{
		var id = $(this).attr('id');

		$('#' + id).modal('hide');
	});
}

$(function()
{
	//$('.filter-left').find('.dropdown-menu').removeClass('dropdown-menu');
	if($.trim($('#message .message').text()).length > 0) $('#message').modal();

	$('body').on('click','a.call,button.call',function(e)
	{
		e.preventDefault();

		var option = $(this).attr('data-option');

		switch(option) 
		{
			
			case 'hamMod':
				$('#menu-Mod').modal();
				break;

			case 'PriceMod':
				$('#price-modal').modal();
				break;

			case 'request':
				var product_id = $(this).attr('data-id');

				$.ajax(
				{
					dataType: 'json',
					type: 'POST',
					method: 'POST',
					cashe: false,
					url: baseurl + 'products',
					data: { ajax: true, option: 'request', product_id: product_id }
				})
				.done(function (product) 
				{
					console.log(product);
					$('#request-modal').find('.subtitle-1').text(product.title);
					$('#request-modal').find('.subtitle-2').text('Код товара: ' + product.sku);
					console.log(product.sku);
					$('#request-modal').find('.imgModal').attr('src', product.image.file_name_small);
					$('#request-modal').find('input[name="subject"]').val('Оставить заявку ' + product.title + product.sku);
					$('#request-modal').modal();
				});
				break;

			case 'menu_tablet':
				$('#menu-tablet').modal();
				break;


		default:
			message('Javascript событие ' + option + ' не найдено Х-(<br />Обратитесь к разработчику');
			break;
		}
	});

	$('img.svg').each(function () {
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');

		$.get(imgURL, function (data) {
			// Get the SVG tag, ignore the rest
			var $svg = $(data).find('svg');

			// Add replaced image's ID to the new SVG
			if (typeof imgID !== 'undefined') {
				$svg = $svg.attr('id', imgID);
			}
			// Add replaced image's classes to the new SVG
			if (typeof imgClass !== 'undefined') {
				$svg = $svg.attr('class', imgClass + ' replaced-svg');
			}

			// Remove any invalid XML tags as per http://validator.w3.org
			$svg = $svg.removeAttr('xmlns:a');

			// Check if the viewport is set, else we gonna set it if we can.
			if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
				$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
			}

			// Replace image with new SVG
			$img.replaceWith($svg);
		}, 'xml');
	});


	$('body').on('click','#switch-min',function () 
	{

		$('.small-menu').hide();

		$('.large-menu').show();
	});

	$('body').on('click','#switch',function () 
	{

		$('.large-menu').hide();

		$('.small-menu').show();
	});


	$('body').on('submit', 'form', function (e) {

		var error = 0;
		var text = '';
		var ac = !$(this).attr('action') ? baseurl : $(this).attr('action');

		var form = $(this);

		$('.required:enabled,.r:enabled', this).each(function () {
			if ($(this).attr('id') == 'agree' && !$(this).is(":checked")) {
				alert('Надо принять условия обработки персональных данных!');
				error++;
			}
			if ($(this).val().length < 1) {
				var name = $(this).attr('name');
				var id = $(this).attr('id');

				if (form.find('label[for="' + name + '"]').length) text += '- <b>' + form.find('label[for="' + name + '"]').eq(0).text() + '</b><br />';else if (form.find('label[for="' + id + '"]').length) text += '- <b>' + form.find('label[for="' + id + '"]').eq(0).text() + '</b><br />';else if ($(this).attr('placeholder').length) text += '- <b>' + $(this).attr('placeholder') + '</b><br />';

				var tagname = $(this).prop("tagName");
				$(this).parent().addClass('has-error');
				if (tagname == 'SELECT') {
					var select_id = $(this).attr('id') + '_chosen';
					$('#' + select_id + '.chosen-container').addClass('invalid');
				}
				error++;
			} else {
				var tagname = $(this).prop("tagName");
				$(this).parent().removeClass('has-error');
				if (tagname == 'SELECT') {
					var select_id = $(this).attr('id') + '_chosen';
					$('#' + select_id + '.chosen-container').removeClass('invalid');
				}
			}
		});

		if (error > 0) {
			if (text.length) {
				text = '<h4>Ошибка</h4><p class="t-large tl-2">Введенные вами данные не будут отпралены, так как не все обязательные поля были заполнены:<br />' + text + '</p>';
				message(text);
			}

			e.preventDefault();
		} else {
			var action = null;

			if ($(this).find('button[type="submit"]').length) action = $(this).find('button[type="submit"]').val();

			if ($('body').hasClass('checkout_page_page') || $('body').hasClass('profile_page_page') || action == 'registration' || action == 'remind') action = null;

			var form = $(this);

			if (action) {
				e.preventDefault();

				$.ajax({
					type: 'POST',
					method: 'POST',
					cashe: false,
					url: baseurl,
					data: { ajax: true, option: action, query: $(this).serialize() }
				})
				.done(function (msg) 
				{
					if (msg && msg != 1) message(msg);
					else if (msg) 
					{
						message('<h4>Благодарим за заявку</h4><br><p class="t-large tl-2">Ваша заявка была успешно отправлена<br />С Вами свяжутся в ближайшее время</p>');
						form.find("input[type=text], textarea").val("");
						$('.modal').modal('hide');
					} 
					else 
					{
						message('<h4>Ошибка</h4><p class="t-large tl-2">Во время отправки сообщения произошла ошибка. Попробуйте еще раз.</p>');
					}
				});
			}
		}
	});

	$('body').on('change', '.select', function()
	{
		option_ = $(this).val();
		document.location.href = option_;
	});
});

$( window ).load(function()
{
	if ($(window).width() > 767 && $('.menu .flex').parent().parent().parent().next().height() > $('.menu .flex').height())
	{
		//console.log(1234);
		var position = $('.menu .flex').offset().top;

		var max_offset = $('.menu .flex').parent().parent().parent().next().height() - $('.menu .flex').height();

		var top  = window.pageYOffset || document.documentElement.scrollTop;

		var offset = (top - position);

		if(offset > max_offset)
			offset = max_offset;

		if(position < top)
			$('.menu .flex').addClass('fix').css('top',offset + 'px');
		else
			$('.menu .flex').removeClass('fix');

		$( window ).scroll(function()
		{
			var top  = window.pageYOffset || document.documentElement.scrollTop;

			var max_offset = $('.menu .flex').parent().parent().parent().next().height() - $('.menu .flex').height();
			
			var offset = (top - position);
			//offset = offset + 100;
			if(offset > max_offset)
				offset = max_offset;

			if(position < top)
				$('.menu .flex').addClass('fix').css('top',offset + 'px');
			else
				$('.menu .flex').removeClass('fix');
		});
	}

	$('.promotional-offers .owl-carousel').owlCarousel(
	{   
	    items:3,
	    dotsContainer: '.promotional-offers .dotscontainer-slider',
	    responsive: {
	    	0: {
	    		items: 1

	    	},
	    	768: {
	    		items: 2

	    	},
	    	968: {
	    		items: 2
	    	},
	    	1024:
	    	{
	    		items:3
	    	}
	    }
	});
		$('.partner .owl-carousel').owlCarousel(
	{   
		loop: false,
	    items:4,
	    responsive: {
	    	0: {
	    		items: 2

	    	},
	    	768: {
	    		items: 3

	    	},
	    	968: {
	    		items: 3
	    	},
	    	1024:
	    	{
	    		items:4
	    	}
	    }
	});

	$(".articles .owl-carousel").owlCarousel(
	{
		items: 1,
		loop: true,
		nav: false,
		dots: true,
		autoplay: false,
		autoplaySpeed: 650
	});

	$(".certificates .owl-carousel").owlCarousel(
	{
		items: 1,
		loop: true,
		nav: false,
		dots: true,
		autoplay: false,
		autoplaySpeed: 650
	});

	$(".gallery .owl-carousel").owlCarousel(
	{
		items: 1,
		loop: false,
		nav: false,
		dots: true,
		autoplay: false,
		autoplaySpeed: 650
	});

});



// WEBPACK FOOTER //
// ../scripts/sources/script.js